import styled from '@emotion/styled';
import { colors, spacing, typography } from '../../../themes/stena-recycling';

export const FileUploadContainer = styled.div`
  display: flex;
  max-width: 900px;
  flex-direction: column;
`;

export const FileUploadLabel = styled.span`
  display: flex;
  ${typography.other.inputLabel}
  margin-bottom: ${spacing.tiny};
  color: ${colors.primary.grey};
`;

export const FileUploadErrorText = styled.span`
  ${typography.body.large}
  color: ${colors.alerts.error};
`;

export const TooltipWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;

export const OuterLabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.tiny};
`;
